import React from 'react'
import WhoHero from '../Components/who/WhoHero'
import FeaturedNewsSection from '../Components/insights/FeaturedNewsSection'
import FeaturedViews from '../Components/insights/FeaturedViews'
import CaseStudiesSection from '../Components/insights/CaseStudiesSection'
import EventsSection from '../Components/insights/EventsSection'

function Insights() {
    return (
        <div>
            <WhoHero
                title="Insights"
                text="Take a tour of our insights section to see our latest press releases, case studies, news coverage, updates and upcoming events"
                imgData="/assets/diversity/bg2.png"
            />
            <FeaturedNewsSection />
            <FeaturedViews />
            <CaseStudiesSection />
            <EventsSection />
        </div>
    )
}

export default Insights
